import { useQuery } from "@apollo/client";
// @ts-ignore
import { GET_CURRENT_ORGANIZATION_USER } from "components/shared/queries/organization_users_query";
import { OrganizationUser } from "types/graphql";

type QueryData = {
  currentOrganizationUser: OrganizationUser;
};

export type CurrentUser = OrganizationUser & {
  isTestManager: boolean;
  isCommunityTestManager: boolean;
};

function useCurrentUser(): CurrentUser | undefined {
  const { data } = useQuery<QueryData>(GET_CURRENT_ORGANIZATION_USER);
  const user = data?.currentOrganizationUser;

  if (!user) return;

  return {
    ...user,
    isTestManager: user.role === "test_manager",
    isCommunityTestManager: user.role === "community_test_manager",
  };
}

export { useCurrentUser };
